// Auto-generated design token constants
// Generated by: scripts/designTokens.js
// Do not edit this file manually

export const TOKENS = {
  color: {
    primary: {
      '50': 'color.primary.50',
      '100': 'color.primary.100',
      '200': 'color.primary.200',
      '300': 'color.primary.300',
      '400': 'color.primary.400',
      '500': 'color.primary.500',
      '600': 'color.primary.600',
      '700': 'color.primary.700',
      '800': 'color.primary.800',
      '900': 'color.primary.900',
    },
    secondary: {
      '50': 'color.secondary.50',
      '100': 'color.secondary.100',
      '200': 'color.secondary.200',
      '300': 'color.secondary.300',
      '400': 'color.secondary.400',
      '500': 'color.secondary.500',
      '600': 'color.secondary.600',
      '700': 'color.secondary.700',
      '800': 'color.secondary.800',
      '900': 'color.secondary.900',
    },
    neutral: {
      '50': 'color.neutral.50',
      '100': 'color.neutral.100',
      '200': 'color.neutral.200',
      '300': 'color.neutral.300',
      '400': 'color.neutral.400',
      '500': 'color.neutral.500',
      '600': 'color.neutral.600',
      '700': 'color.neutral.700',
      '800': 'color.neutral.800',
      '900': 'color.neutral.900',
    },
  },
  spacing: {
    xs: 'spacing.xs',
    sm: 'spacing.sm',
    md: 'spacing.md',
    lg: 'spacing.lg',
    xl: 'spacing.xl',
    xxl: 'spacing.xxl',
    container: {
      mobile: 'spacing.container.mobile',
      tablet: 'spacing.container.tablet',
      desktop: 'spacing.container.desktop',
    },
    button: {
      default: {
        mobile: 'spacing.button.default.mobile',
        tablet: 'spacing.button.default.tablet',
        desktop: 'spacing.button.default.desktop',
      },
    },
  },
  typography: {
    fontFamily: {
      primary: 'typography.fontFamily.primary',
      mono: 'typography.fontFamily.mono',
    },
    fontSize: {
      xs: 'typography.fontSize.xs',
      sm: 'typography.fontSize.sm',
      md: 'typography.fontSize.md',
      lg: 'typography.fontSize.lg',
      xl: 'typography.fontSize.xl',
      xxl: 'typography.fontSize.xxl',
      h1: 'typography.fontSize.h1',
      h2: 'typography.fontSize.h2',
      h3: 'typography.fontSize.h3',
      h4: 'typography.fontSize.h4',
      h5: 'typography.fontSize.h5',
      h6: 'typography.fontSize.h6',
    },
    fontWeight: {
      light: 'typography.fontWeight.light',
      normal: 'typography.fontWeight.normal',
      medium: 'typography.fontWeight.medium',
      semibold: 'typography.fontWeight.semibold',
      bold: 'typography.fontWeight.bold',
    },
    lineHeight: {
      tight: 'typography.lineHeight.tight',
      normal: 'typography.lineHeight.normal',
      relaxed: 'typography.lineHeight.relaxed',
    },
  },
  borderRadius: {
    none: 'borderRadius.none',
    sm: 'borderRadius.sm',
    md: 'borderRadius.md',
    lg: 'borderRadius.lg',
    xl: 'borderRadius.xl',
    full: 'borderRadius.full',
  },
  layout: {
    container: {
      centerPage: {
        display: 'layout.container.centerPage.display',
        flexDirection: 'layout.container.centerPage.flexDirection',
        alignItems: 'layout.container.centerPage.alignItems',
        justifyContent: 'layout.container.centerPage.justifyContent',
        minHeight: 'layout.container.centerPage.minHeight',
      },
      page: {
        maxWidth: 'layout.container.page.maxWidth',
        margin: 'layout.container.page.margin',
        padding: 'layout.container.page.padding',
      },
    },
    button: {
      base: {
        display: 'layout.button.base.display',
        alignItems: 'layout.button.base.alignItems',
        border: 'layout.button.base.border',
        cursor: 'layout.button.base.cursor',
      },
      primary: {
        small: {
          padding: 'layout.button.primary.small.padding',
          fontSize: 'layout.button.primary.small.fontSize',
          backgroundColor: 'layout.button.primary.small.backgroundColor',
          color: 'layout.button.primary.small.color',
        },
        medium: {
          padding: 'layout.button.primary.medium.padding',
          fontSize: 'layout.button.primary.medium.fontSize',
          backgroundColor: 'layout.button.primary.medium.backgroundColor',
          color: 'layout.button.primary.medium.color',
        },
        large: {
          padding: 'layout.button.primary.large.padding',
          fontSize: 'layout.button.primary.large.fontSize',
          backgroundColor: 'layout.button.primary.large.backgroundColor',
          color: 'layout.button.primary.large.color',
        },
      },
      secondary: {
        small: {
          padding: 'layout.button.secondary.small.padding',
          fontSize: 'layout.button.secondary.small.fontSize',
          backgroundColor: 'layout.button.secondary.small.backgroundColor',
          color: 'layout.button.secondary.small.color',
          border: 'layout.button.secondary.small.border',
        },
        medium: {
          padding: 'layout.button.secondary.medium.padding',
          fontSize: 'layout.button.secondary.medium.fontSize',
          backgroundColor: 'layout.button.secondary.medium.backgroundColor',
          color: 'layout.button.secondary.medium.color',
          border: 'layout.button.secondary.medium.border',
        },
        large: {
          padding: 'layout.button.secondary.large.padding',
          fontSize: 'layout.button.secondary.large.fontSize',
          backgroundColor: 'layout.button.secondary.large.backgroundColor',
          color: 'layout.button.secondary.large.color',
          border: 'layout.button.secondary.large.border',
        },
      },
    },
    header: {
      container: {
        display: 'layout.header.container.display',
        justifyContent: 'layout.header.container.justifyContent',
        alignItems: 'layout.header.container.alignItems',
        padding: 'layout.header.container.padding',
        backgroundColor: 'layout.header.container.backgroundColor',
        boxShadow: 'layout.header.container.boxShadow',
      },
      brand: {
        display: 'layout.header.brand.display',
        alignItems: 'layout.header.brand.alignItems',
        gap: 'layout.header.brand.gap',
      },
      nav: {
        display: 'layout.header.nav.display',
        alignItems: 'layout.header.nav.alignItems',
        gap: 'layout.header.nav.gap',
      },
    },
  },
  states: {
    button: {
      primary: {
        default: {
          backgroundColor: 'states.button.primary.default.backgroundColor',
          color: 'states.button.primary.default.color',
        },
        hover: {
          backgroundColor: 'states.button.primary.hover.backgroundColor',
        },
      },
      secondary: {
        default: {
          backgroundColor: 'states.button.secondary.default.backgroundColor',
          color: 'states.button.secondary.default.color',
        },
        hover: {
          backgroundColor: 'states.button.secondary.hover.backgroundColor',
        },
      },
      disabled: {
        backgroundColor: 'states.button.disabled.backgroundColor',
        cursor: 'states.button.disabled.cursor',
      },
    },
  },
  googleButton: {
    base: {
      userSelect: 'googleButton.base.userSelect',
      WebkitUserSelect: 'googleButton.base.WebkitUserSelect',
      MozUserSelect: 'googleButton.base.MozUserSelect',
      msUserSelect: 'googleButton.base.msUserSelect',
      WebkitAppearance: 'googleButton.base.WebkitAppearance',
      backgroundColor: 'googleButton.base.backgroundColor',
      backgroundImage: 'googleButton.base.backgroundImage',
      border: 'googleButton.base.border',
      WebkitBorderRadius: 'googleButton.base.WebkitBorderRadius',
      borderRadius: 'googleButton.base.borderRadius',
      WebkitBoxSizing: 'googleButton.base.WebkitBoxSizing',
      boxSizing: 'googleButton.base.boxSizing',
      color: 'googleButton.base.color',
      cursor: 'googleButton.base.cursor',
      fontFamily: 'googleButton.base.fontFamily',
      fontSize: 'googleButton.base.fontSize',
      height: 'googleButton.base.height',
      letterSpacing: 'googleButton.base.letterSpacing',
      outline: 'googleButton.base.outline',
      overflow: 'googleButton.base.overflow',
      padding: 'googleButton.base.padding',
      position: 'googleButton.base.position',
      textAlign: 'googleButton.base.textAlign',
      WebkitTransition: 'googleButton.base.WebkitTransition',
      transition: 'googleButton.base.transition',
      verticalAlign: 'googleButton.base.verticalAlign',
      whiteSpace: 'googleButton.base.whiteSpace',
      width: 'googleButton.base.width',
      maxWidth: 'googleButton.base.maxWidth',
      minWidth: 'googleButton.base.minWidth',
      '&:hover': {
        WebkitBoxShadow: 'googleButton.base.&:hover.WebkitBoxShadow',
        boxShadow: 'googleButton.base.&:hover.boxShadow',
      },
      '&:disabled': {
        cursor: 'googleButton.base.&:disabled.cursor',
        backgroundColor: 'googleButton.base.&:disabled.backgroundColor',
        borderColor: 'googleButton.base.&:disabled.borderColor',
      },
    },
    icon: {
      height: 'googleButton.icon.height',
      marginRight: 'googleButton.icon.marginRight',
      minWidth: 'googleButton.icon.minWidth',
      width: 'googleButton.icon.width',
    },
    contentWrapper: {
      WebkitAlignItems: 'googleButton.contentWrapper.WebkitAlignItems',
      alignItems: 'googleButton.contentWrapper.alignItems',
      display: 'googleButton.contentWrapper.display',
      WebkitFlexDirection: 'googleButton.contentWrapper.WebkitFlexDirection',
      flexDirection: 'googleButton.contentWrapper.flexDirection',
      WebkitFlexWrap: 'googleButton.contentWrapper.WebkitFlexWrap',
      flexWrap: 'googleButton.contentWrapper.flexWrap',
      height: 'googleButton.contentWrapper.height',
      justifyContent: 'googleButton.contentWrapper.justifyContent',
      position: 'googleButton.contentWrapper.position',
      width: 'googleButton.contentWrapper.width',
    },
    contents: {
      WebkitFlexGrow: 'googleButton.contents.WebkitFlexGrow',
      flexGrow: 'googleButton.contents.flexGrow',
      fontFamily: 'googleButton.contents.fontFamily',
      fontWeight: 'googleButton.contents.fontWeight',
      overflow: 'googleButton.contents.overflow',
      textOverflow: 'googleButton.contents.textOverflow',
      verticalAlign: 'googleButton.contents.verticalAlign',
    },
  },
  breakpoints: {
    mobile: 'breakpoints.mobile',
    tablet: 'breakpoints.tablet',
    desktop: 'breakpoints.desktop',
    wide: 'breakpoints.wide',
  },
} as const

export type TokenPath =
  | `color.${string}`
  | `spacing.${string}`
  | `typography.${string}`
  | `borderRadius.${string}`
  | `layout.${string}`
  | `states.${string}`
  | `googleButton.${string}`
  | `breakpoints.${string}`
